import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const wetBulb_ABOVE: typeof valueTypeRenderers.wetBulb_ABOVE = {
  label: () => unitConverter.wetBulbAboveCanopy().titleWithoutUnit(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.wetBulbAboveCanopy().title(),
      render: (n) => unitConverter.wetBulbAboveCanopy(n).valueAsString(),
    }),
}
